function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "KEY"
}, React.createElement("path", {
  d: "M0,1.35042756 C0,0.604607012 0.60450369,0 1.35034656,0 L12.823307,0 L19.028133,6.22490406 L19.028133,22.6493894 C19.028133,23.395311 18.4232488,24 17.6777828,24 L1.3503502,24 C0.604572376,24 0,23.3954884 0,22.6495724 L0,1.35042756 Z",
  id: "Rectangle-Copy-8",
  fill: "#FFD71B",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M19.0895141,6.38363171 L13.4697357,6.38363171 C13.081971,6.38363171 12.7672634,6.06586871 12.7672634,5.6743393 L12.7672634,0",
  id: "Fill-139-Copy-8",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0.207823822
}), React.createElement("path", {
  d: "M4.0511509,14.4859335 L4.0511509,18.4302813 L4.91846547,18.4302813 L4.91846547,17.1596931 L5.41565217,16.6569821 L6.60337596,18.4302813 L7.6916624,18.4302813 L6.00122762,16.0437852 L7.54250639,14.4859335 L6.45974425,14.4859335 L4.91846547,16.1211253 L4.91846547,14.4859335 L4.0511509,14.4859335 Z M8.03969309,14.4859335 L8.03969309,18.4302813 L11.0338619,18.4302813 L11.0338619,17.7010742 L8.90700767,17.7010742 L8.90700767,16.7343223 L10.8184143,16.7343223 L10.8184143,16.0603581 L8.90700767,16.0603581 L8.90700767,15.2151407 L10.9896675,15.2151407 L10.9896675,14.4859335 L8.03969309,14.4859335 Z M12.6414322,16.8945269 L12.6414322,18.4302813 L13.5087468,18.4302813 L13.5087468,16.916624 L14.9726854,14.4859335 L14.0059335,14.4859335 L13.0889003,16.0437852 L12.1663427,14.4859335 L11.1940665,14.4859335 L12.6414322,16.8945269 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.e44d3c81.svg";
export { ForwardRef as ReactComponent };